<template>
  <div style="width: 100%;">
    <div v-for="i in 5" :key="i" class="container-skeleton mb-2">
      <div v-for="(num, index) in widths" :key="index" class="ml-1 skeleton-box" :style="`width: ${num}%; height: 15px;`" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      widths: [80, 70, 75, 90 ,80]
    }
  }
}
</script>

<style lang="scss" scoped>
  .container-skeleton {
    width: 100%;
  }
  .skeleton-box {
  display: inline-block;
  height: 1em;
  position: relative;
  overflow: hidden;
  background-color: #DDDBDD;
  border-radius: 8px;

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(
      90deg,
      rgba(#fff, 0) 0,
      rgba(#fff, 0.2) 20%,
      rgba(#fff, 0.5) 60%,
      rgba(#fff, 0)
    );
    animation: shimmer 2s infinite;
    content: '';
  }

  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
}

</style>